/**
 * exercise-edit-button-steps.js
 */

import React from 'react';
import TourStep from '../tour-step';
import tourStepProps from '../tour-step-props';


export default [
  {
    target: "[data-testid='edit-button']",
    title: "Viewing & Editing",
    ...tourStepProps,
    placement: 'left',
    isFixed: true,
    content: (
      <TourStep>
        You're currently viewing a summary of this exercise.
        Click this pencil button any time to edit the information below.
        You'll see the pencil in many places throughout PACKTRACK where data can be edited.
      </TourStep>
    ),
  },
];
